import React, { useState } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppOverviewData from "./AppOverviewData";

export default function AppOverviewModal() {
  const [openOverViewM, setOverView] = useState(false);

  const handleClose = () => {
    setOverView(false);
  };

  return (
    <>
      <li
        className="dropDownItem"
        onClick={() => {
          setOverView(true);
        }}
      >
        <FontAwesomeIcon icon={faInfoCircle} className="userProfileAvatar" />
        Overview
      </li>
      <AppOverviewData
        handleClose={handleClose}
        openOverViewM={openOverViewM}
      />
    </>
  );
}
